import merge from 'lodash/merge';
import BaseSingleton from '../../base/base_singleton';
import DOM from '../../utils/dom';
import ObservableFactory from '../../utils/observable_factory';


export default class WebLoginComponent extends BaseSingleton {

    static CLASS = 'WebLoginComponent';

    init(params) {
        super.init(params);

        this._serviceFactory = params.serviceFactory;

        if(!params.sdkUrl) {
            this._serviceFactory.structuredLoggingService()
                .getLogger()
                .addCategory('web_login_component')
                .addAction('missing_sdkUrl_config')
                .error();
            this.throwError('22', 'Missing WebLogin.sdkUrl configuration parameter! Make sure you provided this value in the web.config');
        }

        this._sdkUrl = params.sdkUrl;
        this._initObjectBuilder = params.initObjectBuilder;
        this._eventsObjectBuilder = params.eventsObjectBuilder;
        this._observableFactory = ObservableFactory.create();
        this._loadWebLoginSDK();
    }

    _initObjectBuilder = null;
    _eventsObjectBuilder = null;
    _sdkUrl = null;
    _isWebLoginComponentLoaded = false;
    _observableFactory = null;


    _loadWebLoginSDK() {
        this._serviceFactory
            .scriptLoaderService()
            .loadScript({
                url: this._sdkUrl,
                tagId: 'rllogin_loader'
            })
            .then(() => {
                window.rllogin = new window.RL.PF.Web.LoginUi.Login(this._buildInitObject(), this._buildEventsObject());
            }, () => {
                this.logger.error(`Failed to load web login component sdk from ${this._sdkUrl}.`);
                this._serviceFactory.structuredLoggingService()
                    .getLogger()
                    .addCategory('web_login_component')
                    .addAction('sdk_load_failed')
                    .addValue(this._sdkUrl)
                    .error();

                const secondsUntilNewRetryBulk = 15;
                DOM.setTimeout(() => {
                        this._loadWebLoginSDK();
                    },
                    secondsUntilNewRetryBulk * 1000);
            });
    }

    _buildEventsObject() {
        let commonEventsObject = {
            onerror: (err) => {
                this.logger.error('WebLoginComponent error', err);
            },
            onload: () => {
                this._isWebLoginComponentLoaded = true;
            }
        };
        return Object.assign(commonEventsObject, this._eventsObjectBuilder.buildEventsObject());
    }

    _buildInitObject() {
        return this._initObjectBuilder.buildInitObject();
    }


    _loginComponentWrapperElement = null;
    show(params = {}) {
        return this._getWebLoginComponent().then(component => {
            component.updateform( merge(this._initObjectBuilder.buildFormOptions(), params) );
            //component.show();
        });
    }

    hide() {
        return this._getWebLoginComponent().then(component => {
            component.hide();
            if(this._loginComponentWrapperElement) {
                document.removeChild(this._loginComponentWrapperElement)
            }
        });
    }

    processResponse(response) {
        return this._getWebLoginComponent()
            .then(() => {
                return window.RL.PF.Web.LoginUi.Login.processresponse(response);
            });
    }

    getDeviceUUID() {
        return this._getWebLoginComponent()
            .then(component => {
                return component.getDeviceUUID();
            });
    }

    _getWebLoginComponent() {
        if(this._isWebLoginComponentLoaded) {
            return Promise.resolve(window.rllogin);
        }

        return new Promise(this._getWebLoginComponentPromiseHandler.bind(this));
    }

    _getWebLoginComponentPromiseHandler(resolve, reject) {
        let retryCount = 200; // we retry maximum 200 times every 100 milliseconds => 20 seconds

        let subscription = this._observableFactory.fromInterval(100).forEach(() => {
            if(this._isWebLoginComponentLoaded) {
                subscription.dispose();
                resolve(window.rllogin);
            }
            else {
                if(retryCount === 0) {
                    subscription.dispose();
                    this._serviceFactory.structuredLoggingService()
                        .getLogger()
                        .addCategory('web_login_component')
                        .addAction('get_handler_timeout')
                        .error();
                    reject('Failed to load WebLoginComponent');
                }
                retryCount--;
            }
        });
    }
}
